module.exports = __webpack_public_path__ + "static/pic05-d807cd22513b617c9bd5a9d0a8658b11.jpg";